class MATAProductTopCarousel {
  constructor( i, e ) {
    this.$index = i;
    this.$element = $( e );

    this.selectors = {
      item: ".product-top__media",
      thumbnails: ".product-top__media-thumbnails",
    };

    this.init();
  }

  init() {
    this.$thumbnails = this.$element.find( `+ ${this.selectors.thumbnails}` );

    this.initCarousel();
  }

  initCarousel() {

    this.$element.flickity({
      wrapAround: false,
      prevNextButtons: true,
      adaptiveHeight: false,
      pageDots: false,
      cellAlign: "left",
      groupCells: false,
      contain: true,
      autoPlay: 2500,
      on: {
        ready: () => {
          this.$thumbnails.flickity({
            asNavFor: this.$element.get(0),
            wrapAround: false,
            prevNextButtons: false,
            adaptiveHeight: false,
            pageDots: false,
            cellAlign: "center",
            groupCells: false,
            contain: true,
            freeScroll: true
          });
        }
      }
    });
  }
}